export default "__VITE_ASSET__BJzeIObN__"